import type { ReactElement } from 'react';
import { useSiteSettingsQuery } from '@/entities/site/setting';
import { KakaoChannelForm } from '@/features/site-setting/kakao-channel';
import { ContentCard, EmptyState } from '@/shared/ui';

/**
 * 카카오톡 채널 설정(/settings/site) — 한 번의 조회로 카카오톡 상담 버튼 카드를 보인다. 저장 뒤 새 설정이 오면(updatedAt 이 바뀐다)
 * 폼을 key 로 다시 시작해 새 값을 보인다.
 */
export const SiteSettingsPanel = (): ReactElement => {
  const settingsQuery = useSiteSettingsQuery();

  if (settingsQuery.isPending) {
    return <EmptyState>카카오톡 채널 설정을 불러오는 중…</EmptyState>;
  }

  if (settingsQuery.isError) {
    return (
      <EmptyState isError>
        {`카카오톡 채널 설정을 불러오지 못했습니다: ${settingsQuery.error.message}`}{' '}
        <button type="button" className="underline" onClick={() => void settingsQuery.refetch()}>
          다시 시도
        </button>
      </EmptyState>
    );
  }

  const settings = settingsQuery.data;
  return (
    <ContentCard
      title="카카오톡 상담 버튼"
      description="고객이 카카오톡으로 바로 상담할 수 있는 버튼입니다. 카카오 비즈니스 채널을 만들고 1:1 채팅을 켠 뒤 채널 주소를 넣어 주세요."
    >
      <KakaoChannelForm key={settings.updatedAt ?? 'initial'} settings={settings} />
    </ContentCard>
  );
};
